import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    whatsappUrl: String,
    email: String,
    patientName: String,
    appointmentId: String,
    doctorName: String
  }

  sendToWhatsApp() {
    // Validar que la URL sea válida
    if (!this.whatsappUrlValue || this.whatsappUrlValue === '' || !this.whatsappUrlValue.startsWith('https://api.whatsapp.com/')) {
      alert('Error: El paciente no tiene un teléfono válido registrado para WhatsApp');
      console.error('URL inválida:', this.whatsappUrlValue);
      return;
    }

    // Obtener la tabla del historial
    const table = document.querySelector('#collapseHistory table');
    if (!table) {
      alert('No hay datos de historial para enviar');
      return;
    }

    // Generar el texto del historial formateado
    let historyText = `Hola, te envío el historial de las consultas registradas en Cooking4U con el Dr. ${this.doctorNameValue}:\n\n`;
    historyText += `📊 *HISTORIAL DE CONSULTAS*\n`;
    historyText += `\n👨‍⚕️ *Doctor:* ${this.doctorNameValue}\n`;
    historyText += `👤 *Paciente:* ${this.patientNameValue}\n`;
    historyText += `📅 *Generado:* ${new Date().toLocaleDateString('es-AR')}\n`;
    historyText += `⏰ *Hora:* ${new Date().toLocaleTimeString('es-AR')}\n\n`;
    historyText += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;

    // Obtener los headers
    const headers = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent.trim());

    // Obtener las filas de datos (máximo 10, solo completadas)
    const allRows = table.querySelectorAll('tbody tr');
    const completedRows = Array.from(allRows).filter(row => {
      // Buscar si la fila tiene datos de consulta (peso, BMI, etc.)
      const cells = Array.from(row.querySelectorAll('td')).map(td => td.textContent.trim());
      // Si tiene datos de peso, BMI, etc., significa que está completada
      return cells[2] && cells[2] !== '-' && cells[4] && cells[4] !== '-';
    });
    const rows = completedRows.slice(0, 10);

    if (rows.length === 0) {
      historyText += `❌ *No hay consultas registradas*\n`;
    } else {
      // Agregar cada fila al texto con formato simple
      rows.forEach((row, index) => {
        const cells = Array.from(row.querySelectorAll('td')).map(td => td.textContent.trim());

        historyText += `📋 *CONSULTA ${cells[0]} ${cells[1]}*\n`;

        // Agregar todos los campos disponibles
        if (cells[2] && cells[2] !== '-') historyText += `⚖️ Peso: ${cells[2]} kg\n`;
        if (cells[3] && cells[3] !== '-') historyText += `🔥 BMR: ${cells[3]}\n`;
        if (cells[4] && cells[4] !== '-') historyText += `📏 BMI: ${cells[4]}\n`;
        if (cells[5] && cells[5] !== '-') historyText += `💧 TBW - Agua: ${cells[5]} kg\n`;
        if (cells[6] && cells[6] !== '-') historyText += `🩸 FAT WT - Grasa: ${cells[6]} kg\n`;
        if (cells[7] && cells[7] !== '-') historyText += `💪 FFM: ${cells[7]}\n`;
        if (cells[8] && cells[8] !== '-') historyText += `📊 Grasa (%): ${cells[8]}%\n`;
        if (cells[10] && cells[10] !== '-') historyText += `📐 Cintura: ${cells[10]} cm\n`;
        if (cells[11] && cells[11] !== '-') historyText += `📐 Cadera: ${cells[11]} cm\n`;
        if (cells[12] && cells[12] !== '-') historyText += `📈 CCC: ${cells[12]}\n`;
        if (cells[13] && cells[13] !== '-') historyText += `🫁 Grasa Visceral: ${cells[13]}\n`;
        if (cells[14] && cells[14] !== '-') historyText += `💪 MME: ${cells[14]} kg\n`;
        if (cells[15] && cells[15] !== '-') historyText += `⏳ Edad: ${cells[15]} años\n`;

        historyText += `\n`;
      });
    }

    historyText += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    historyText += `📊 *Mostrando:* ${rows.length} de ${completedRows.length} consultas completadas\n`;
    historyText += `📝 *Nota:* Se muestran las últimas 10 consultas más recientes`;

    // Verificar que el texto no sea demasiado largo (WhatsApp tiene límites)
    if (historyText.length > 4000) {
      // Si es muy largo, truncar y agregar nota
      historyText = historyText.substring(0, 3900) + '\n\n... (historial truncado por límite de WhatsApp)';
    }

    // Codificar el texto para la URL
    const encodedText = encodeURIComponent(historyText);

    // Construir la URL final de WhatsApp
    const separator = this.whatsappUrlValue.includes('?') ? '&' : '?';
    const finalUrl = `${this.whatsappUrlValue}${separator}text=${encodedText}`;

    // Abrir WhatsApp
    window.open(finalUrl, '_blank');
  }

    sendToEmail() {
    // Validar que el email sea válido
    if (!this.emailValue || this.emailValue === '') {
      alert('Error: El paciente no tiene un email válido registrado');
      console.error('Email inválido:', this.emailValue);
      return;
    }

    // Validar que el appointment_id esté disponible
    if (!this.appointmentIdValue || this.appointmentIdValue === '') {
      alert('Error: No se pudo identificar la consulta actual');
      console.error('Appointment ID inválido:', this.appointmentIdValue);
      return;
    }

    // Mostrar indicador de carga
    const button = event.target;
    const originalText = button.innerHTML;
    button.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i>Enviando...';
    button.disabled = true;

    // Enviar el email con el PDF adjunto
    fetch('/pdf/send_history_email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({
        appointment_id: this.appointmentIdValue
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        alert('✅ Email enviado correctamente al paciente');
      } else {
        alert(`❌ Error al enviar el email: ${data.message}`);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('❌ Error al enviar el email. Por favor, inténtalo de nuevo.');
    })
    .finally(() => {
      // Restaurar el botón
      button.innerHTML = originalText;
      button.disabled = false;
    });
  }

  downloadPDF() {
    // Validar que el appointment_id esté disponible
    if (!this.appointmentIdValue || this.appointmentIdValue === '') {
      alert('Error: No se pudo identificar la consulta actual');
      console.error('Appointment ID inválido:', this.appointmentIdValue);
      return;
    }

    // Generar y descargar el PDF
    const pdfUrl = `/pdf/history_pdf?appointment_id=${this.appointmentIdValue}`;

    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `historial_consultas_${this.patientNameValue.replace(/\s+/g, '_')}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
